import React, { useState } from 'react';
import { sceneSlice } from '../../../store/reducers/SceneReducer';
import { useAppDispatch, useAppSelector } from '../../../store/store';
import BaseButton from '../../ui/BaseButton';
import npc from '../../../assets/img/characters_img/npc/character_upgrade_npc.png'
import npcWebp from '../../../assets/img/characters_img/npc/character_upgrade_npc.webp'
import './CampCharacterUpgrade.scss'
import { IObjectOfImprovedStats, TStatName } from '../../../mechanics/characters/Character';
import ImgWithFallback from '../../ui/ImgWithFallback';

const CampCharacterUpgrade = () => {
    // redux const 
    const dispatch = useAppDispatch()
    const { setScene } = sceneSlice.actions
    const character = useAppSelector(state => state.userReducer.character)
    // state const
    const [showConfirm, setShowConfirm] = useState(false)
    const [chosenStats, setChosenStats] = useState<TStatName[]>([])
    const [init, setInit] = useState(true)
    const [conCounter, setConCounter] = useState(0)
    const [dexCounter, setDexCounter] = useState(0)
    const [strCounter, setStrCounter] = useState(0)
    const [chrCounter, setChrCounter] = useState(0)
    const [wisCounter, setWISCounter] = useState(0)
    const [intCounter, setIntCounter] = useState(0)
    const [itemToStatUpNeed, setItemToStatUpNeed] = useState(character.getLevel().itemToStatUpNeed)
    const [itemToStatUpAmount, setItemToStatUpAmount] = useState(character.getLevel().itemToStatUpAmount)

    const backClick = () => {
        dispatch(setScene("camp"))
    }

    const handleClick = (e: React.MouseEvent<HTMLTableRowElement, MouseEvent>) => {
        const stat = (e.target as HTMLInputElement).dataset.stat as TStatName

        if (itemToStatUpNeed > itemToStatUpAmount) return

        setShowConfirm(true)
        setInit(false)

        if (stat) {
            let have = false

            chosenStats.forEach(chosenStat => {
                if (chosenStat === stat) have = true
            })

            if (!have) setChosenStats([...chosenStats, stat])

            switch (stat) {
                case 'Constitution':
                    setConCounter(conCounter + 1)
                    break
                case 'Dexterety':
                    setDexCounter(dexCounter + 1)
                    break
                case 'Strength':
                    setStrCounter(strCounter + 1)
                    break
                case 'Charm':
                    setChrCounter(chrCounter + 1)
                    break
                case 'Wisdom':
                    setWISCounter(wisCounter + 1)
                    break
                case 'Intelligent':
                    setIntCounter(intCounter + 1)
                    break
                default:
                    break;
            }

            setItemToStatUpNeed(itemToStatUpNeed + 1)
            setItemToStatUpAmount(itemToStatUpAmount - itemToStatUpNeed)
        }
    }

    const improvedStats: IObjectOfImprovedStats = {
        "Constitution": { upgradeStatValue: conCounter },
        "Dexterety": { upgradeStatValue: dexCounter },
        "Strength": { upgradeStatValue: strCounter },
        "Charm": { upgradeStatValue: chrCounter },
        "Wisdom": { upgradeStatValue: wisCounter },
        "Intelligent": { upgradeStatValue: intCounter },
    }

    const confirm = () => {
        character.improveStat(chosenStats, improvedStats)
        setInit(true)
        setShowConfirm(false)
        setConCounter(0)
        setDexCounter(0)
        setStrCounter(0)
        setChrCounter(0)
        setWISCounter(0)
        setIntCounter(0)
    }

    return (
        <div className='camp-character component'>
            <div className="camp-character__wrapper">
                <h1 className="camp-character__title component-title">Character upgrade</h1>
                <div className="camp-character__content">
                    <div className="camp-character__content-img adaptive-img-contain">
                        <ImgWithFallback
                            src={npcWebp}
                            fallbackSrc={npc}
                            alt="npc" />
                    </div>
                    <div className="camp-character__content-info info">
                        <h2 className="info__title">If you have enough "{character.getLevel().itemToStatUpName}", I can upgrade your stat </h2>
                        <h4 className="info__subtitle">Improve your level to get necessary items</h4>
                        <h3>For next upgrade you need <strong>{itemToStatUpNeed}</strong> item.
                            You have <strong>{itemToStatUpAmount}</strong>
                        </h3>
                        <div className="info__body">
                            <table>
                                <thead>
                                    <tr>
                                        <th>Stats name</th>
                                        <th>Total value</th>
                                        <th>Improved</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr data-stat='Constitution' onClick={(e) => handleClick(e)}>
                                        <td>Constitution</td>
                                        <td>{character.getCon()}</td>
                                        <td>{init ?
                                            character.getImprovedStats().Constitution.upgradeStatValue :
                                            `+${conCounter}`}
                                        </td>
                                    </tr>
                                    <tr data-stat='Dexterety' onClick={(e) => handleClick(e)}>
                                        <td>Dexterety</td>
                                        <td>{character.getDex()}</td>
                                        <td>{init ?
                                            character.getImprovedStats().Dexterety.upgradeStatValue :
                                            `+${dexCounter}`}
                                        </td>
                                    </tr>
                                    <tr data-stat='Strength' onClick={(e) => handleClick(e)}>
                                        <td>Strength</td>
                                        <td>{character.getStr()}</td>
                                        <td>{init ?
                                            character.getImprovedStats().Strength.upgradeStatValue :
                                            `+${strCounter}`}
                                        </td>
                                    </tr>
                                    <tr data-stat='Charm' onClick={(e) => handleClick(e)}>
                                        <td>Charm</td>
                                        <td>{character.getChr()}</td>
                                        <td>{init ?
                                            character.getImprovedStats().Charm.upgradeStatValue :
                                            `+${chrCounter}`}
                                        </td>
                                    </tr>
                                    <tr data-stat='Wisdom' onClick={(e) => handleClick(e)}>
                                        <td>Wisdom</td>
                                        <td>{character.getWis()}</td>
                                        <td>{init ?
                                            character.getImprovedStats().Wisdom.upgradeStatValue :
                                            `+${wisCounter}`}
                                        </td>
                                    </tr>
                                    <tr data-stat='Intelligent' onClick={(e) => handleClick(e)}>
                                        <td>Intelligent</td>
                                        <td>{character.getInt()}</td>
                                        <td>{init ?
                                            character.getImprovedStats().Intelligent.upgradeStatValue :
                                            `+${intCounter}`}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <div className='camp-character__btns'>
                    <BaseButton name='Back' onClick={backClick} />
                    {showConfirm && <BaseButton name='Confirm' onClick={confirm} />}
                </div>
            </div>
        </div>
    );
};

export default CampCharacterUpgrade;